import styled from "styled-components";
import Hero from "src/components/Hero/Hero";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import { Link } from "react-router-dom";
import ResponsiveImage from "src/components/ImageWrapper/ResponsiveImage";
import Button from "src/components/Button/Button";
import TitleSection from "src/components/TitleSection/TitleSection";
import SubTitleSection from "src/components/SubTitleSection/SubTitleSection";
import EventFinished from "src/components/EventFinished";
import { useIsMdScreenUp } from "src/utils/windowUtils";

const DragonAfterHours2025 = () => {
  const { t, i18n } = useTranslation();

  return (
    <DragonAfterHoursDiv>
      <EventFinished scheduleKeyName="dragonAfterHours2025" />
      <Hero
        bgImage={!useIsMdScreenUp() ? "restaurants/drunken-after-hours/Dragon_After_Dark_Mobile_Header.jpg" : "restaurants/drunken-after-hours/Dragon_After_Dark_lp_Header.jpg"}
        buttonSettings={null}
        darkenBg={0.5}
        title={t("dragonAfterHours2025.hero.title")}
        // description={t("dragonAfterHours2025.hero.description")}
        descriptionBgColor="#0000004d"
      />
      <MainContentDiv>
        <container-div>
          <TitleSection
            as={"h2"}
            title={t("dragonAfterHours2025.content.title")}
            text={t("dragonAfterHours2025.content.description")}
            borderColor="#CBB695"
            className="pt-3 pb-0"
          />
          <Row className="g-4 mb-0 mt-0 align-items-center text-center" id="">
            <Col className="mt-0" xs={12} md={12}>
              <Box>
                <TitleSection
                  as={"h3"}
                  dark
                  title={t("dragonAfterHours2025.content.subtitle")}
                  text={t("dragonAfterHours2025.content.text")}
                  borderColor="var(--mutedred)"
                  className="pt-0 pb-0"
                  />
                <ReactMarkdown>{t("dragonAfterHours2025.content.details")}</ReactMarkdown>
                <TitleSection
                  as={"h4"}
                  dark
                  title={t("dragonAfterHours2025.content.dragonTitle")}
                  text={t("dragonAfterHours2025.content.subtitle2")}
                  borderColor="var(--mutedred)"
                  className="pt-0 pb-0"
                  />
                <ReactMarkdown className="" >
                  {t("dragonAfterHours2025.content.list")}
                </ReactMarkdown>
                </Box>
                <ReactMarkdown>
                  {t("dragonAfterHours2025.content.atmosphere")}
                </ReactMarkdown>
                <ReactMarkdown className="mt-3">
                  {t("dragonAfterHours2025.content.when")}
                </ReactMarkdown>
                <ReactMarkdown className="mt-3">
                  {t("dragonAfterHours2025.content.reserve")}
                </ReactMarkdown>
                <Button
                  label={t("dragonAfterHours2025.content.buttonText")}
                  href={t("dragonAfterHours2025.content.buttonLink")}
                  color="white "
                />
            </Col>
          </Row>
        </container-div>
      </MainContentDiv>
    </DragonAfterHoursDiv>
  );
};

const DragonAfterHoursDiv = styled.div`
  width: 100%;
  height: auto;
  /* min-height: 100vh; */
  background: var(--lightblack);
  color: var(--white);
  padding-bottom: 1rem;
  .hero_container {
    min-height: 450px;
  }
  .hero_image {
    padding: 2rem 2rem 4rem;
    @media (min-width: 768px) {
      padding: 3rem;
    }
    opacity: 0.9;
  }
  .small {
    text-align: center;
  }
  strong {
    color: #CBB695;
  }
`;

const Box = styled.div`
  background-color: #CBB695;
  padding: 2rem 1rem;
  margin: 2rem 0;
  border-radius: 0.5rem;
  color: var(--black);
  strong {
    color: var(--mutedred);
  }
  h4 {
    color: var(--black);
    font-size: 1.5rem;
    margin-bottom: 0;
    border-left: none;
  }
  p {
    max-width: 800px;
    margin: 0 auto;
  }
`;

const MainContentDiv = styled.div`
  padding-bottom: 1rem;
  h2:after {
    border-color: #c7b997;
  }
  @media (min-width: 768px) {
    padding: 2rem 1rem 1rem;
  }
  container-div {
    background-color: var(--lightblack);
  }
  @media (min-width: 992px) {
    padding: 3rem 0;
  }
  height: auto;
  width: 100%;
  text-align: left;
  ul {
    margin-top: 1rem;
    margin-bottom: 1rem;
    p {
      margin: 10px 0;
    }
    li {
      white-space: unset;
      list-style: none;
      &:before {
        content: "•";
        color: var(--mutedred);
        font-weight: bold;
        display: inline-block;
        width: 1em;
        margin-left: -1em;
      }
    }
  }
  .row {
    display: flex;
    justify-content: space-between;
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
    .col-12 {
      .subtitle-section {
        @media (min-width: 768px) {
          padding-top: 0;
        }
      }
    }
  }
`;

export default DragonAfterHours2025;
